import { useContext, createContext, PropsWithChildren, useCallback, useRef, useState } from 'react';
import { Toast, ToastElementProps } from '@/storybook/components/Toast/ToastElement';
import Styles from './Toast.module.css';
import ToastElement from './ToastElement';

const ToastContext = createContext<{ makeToast: (toast: Toast) => void }>({ makeToast: () => {} });

export const useToast = () => useContext(ToastContext);

export default function ToastProvider({ children }: PropsWithChildren) {
  const [toastList, setToastList] = useState<Array<ToastElementProps>>([]);
  const nextToastId = useRef(0);

  const dropToast = useCallback(
    (toastId: string) => setToastList(prevToasts => [...prevToasts].filter(toast => toast.id !== toastId)),
    [setToastList],
  );

  const makeToast = useCallback(
    (toast: Toast) => {
      const newToast: ToastElementProps = {
        ...toast,
        id: toast.id || `toast-${(nextToastId.current += 1)}`,
        onClose: dropToast,
      };
      setToastList(prevToasts => [...prevToasts, newToast]);
    },
    [dropToast],
  );

  return (
    <ToastContext.Provider value={{ makeToast }}>
      {toastList.length > 0 && (
        <div className={Styles.toastContainer}>
          {toastList.map(toast => (
            <ToastElement {...toast} key={toast.id} />
          ))}
        </div>
      )}
      {children}
    </ToastContext.Provider>
  );
}
